import { fmtDate, fmtDateTime, fmtTime } from './impl/fmt'
import { translate, translationInfo } from './impl/translate'
import type { TranslationContext } from './types/ctx'
import type { TranslationKey } from './types/keys'
import type { TranslationValueKind } from './types/values'

export class Translator implements TranslationContext {
	#id: string
	#timezone: string
	#keys: Record<string, TranslationKey>

	get id(): string {
		return this.#id
	}
	get timezone(): string {
		return this.#timezone
	}
	get keys(): Readonly<Record<string, TranslationKey>> {
		return this.#keys
	}

	constructor({
		id,
		timezone,
		keys = {},
	}: {
		id: string
		timezone: string
		keys?: Readonly<Record<string, TranslationKey>>
	}) {
		this.#id = id
		this.#timezone = timezone
		this.#keys = { ...keys }
	}

	addKeys(keys: Readonly<Record<string, TranslationKey>>) {
		this.#keys = { ...keys, ...this.#keys }
	}

	translate(key: string, params?: Readonly<Record<string, unknown>>): string {
		return translate(this, key, params)
	}
	translationInfo(key: string): {
		keys: string[]
		params: Record<string, TranslationValueKind[]>
	} | null {
		return translationInfo(this, key)
	}

	fmtDate(date: string | Date, fmt: 'short' | 'long' | 'full'): string {
		return fmtDate(this, date, fmt)
	}
	fmtTime(date: string | Date, fmt: 'short' | 'long'): string {
		return fmtTime(this, date, fmt)
	}
	fmtDateTime(date: string | Date, fmt: 'short' | 'long'): string {
		return fmtDateTime(this, date, fmt)
	}
}
